export default __webpack_public_path__ + "static/media/drop-off-pin-orange-green.708ac02e.svg";